import { fork, take } from "redux-saga/effects";


import actionTypes from "../actionTypes";


function* getRaffleTickets(): any {
  /*const storeMission = yield select(getGameBoxMissionActualData);
  const raffleMission =
    !!storeMission &&
    storeMission.filter((mission: { prize: { type: string; } }) => mission?.prize?.type === "raffleTicket");
  if (raffleMission.length) {
    try {
      const headers = {};
      const token = yield select(getToken);
      headers["x-access-token"] = JSON.stringify(token);
      const response = yield call(
        apiGet,
        'REACT_APP_GAMEBOX_URL',
        apiRoutes.GET_ACTIVE_JACKPOT_TICKETS,
        { token },
        headers
      );

      if (response?.data?.success) {
        yield put(successGameBoxRaffleTicket(response.data?.result));
      } else {
        console.log("getActiveRafflesTickets failure");
      }
    } catch (error) {
      console.log("getActiveRafflesTickets failure", error);
    }
  }*/
}

export default function* watchGameBoxRaffleTicketRequest() {
  while (true) {
    yield take([
      actionTypes.GAME_BOX_JACKPOT_SUCCESS,
      actionTypes.GAME_BOX_JACKPOT_TICKETS_REQUEST,
    ]);
    yield fork(getRaffleTickets);
  }
}
